import { locItem } from '../../model/game';

import { CampConfig, Theme } from './types';

export const gobvill: CampConfig = {
  type: 'camp',
  prefix: 'gobvill_',
  perimeter: [
    {
      id: 'guardtower',
      theme: Theme.GoblinCamp,
      size: [7, 8, 7],
      weight: 1,
      items: [
        locItem('GoblinArcher', 1, 2),
        locItem('Goblin', 0.5),
      ],
      dist: [0.529, 0.343, 0.088, 0.030, 0.010],
    },
    {
      id: 'woodwall',
      theme: Theme.GoblinCamp,
      size: [10, 8, 2],
      weight: 1,
      items: [], // 5x fence
      dist: [0.186, 0.363, 0.294, 0.098, 0.049, 0.010],
    },
    {
      id: 'woodwall2',
      theme: Theme.GoblinCamp,
      size: [10, 8, 2],
      weight: 1,
      items: [], // 5x fence
      dist: [0.205, 0.344, 0.304, 0.137, 0.010],
    },
    {
      id: 'guardplatform',
      theme: Theme.GoblinCamp,
      size: [5, 8, 8],
      weight: 1,
      items: [
        locItem('GoblinArcher', 1),
        locItem('Goblin', 0.5),
      ],
      dist: [0.431, 0.353, 0.177, 0.029, 0.010],
    },
    {
      id: 'stakes',
      theme: Theme.GoblinCamp,
      size: [10, 8, 3],
      weight: 1,
      items: [
        locItem('GoblinArcher', 0.5),
        locItem('Goblin', 0.5),
        locItem('piece_sharpstakes', 1, 3),
      ],
      dist: [0.265, 0.392, 0.255, 0.088],
    },
    {
      id: 'platform',
      theme: Theme.GoblinCamp,
      size: [6, 8, 9],
      weight: 1,
      items: [
        locItem('GoblinArcher', 1, 2),
        locItem('Goblin', 0.5),
      ],
      dist: [0.608, 0.275, 0.088, 0.029],
    },
  ],
  inner: [
    {
      id: 'barley',
      theme: Theme.GoblinCamp,
      size: [10, 8, 7],
      weight: 1,
      items: [
        locItem('Goblin', 0.5),
        locItem('Barley', 1, 12),
      ],
      dist: [0.343, 0.363, 0.225, 0.069],
    },
    {
      id: 'flax',
      theme: Theme.GoblinCamp,
      size: [10, 8, 7],
      weight: 1,
      items: [
        locItem('Goblin', 0.5, 2),
        locItem('Flax', 1, 11),
      ],
      dist: [0.471, 0.294, 0.186, 0.030, 0.019],
    },
    {
      id: 'crafting',
      theme: Theme.GoblinCamp,
      size: [5, 8, 5],
      weight: 1,
      items: [
        locItem('Goblin', 0.5, 2),
        locItem('piece_workbench_ext2', 1, 2),
        locItem('TreasureChest_heath'),
      ],
      dist: [0.098, 0.137, 0.196, 0.216, 0.167, 0.098, 0.039, 0.020, 0.029],
    },
    {
      id: 'bonfire',
      theme: Theme.GoblinCamp,
      size: [8, 8, 8],
      weight: 1,
      items: [
        locItem('goblin_totempole', 0.5),
        locItem('bonfire'),
        locItem('Goblin', 0.5, 3),
        locItem('GoblinBrute', 0.5),
        locItem('GoblinShaman', 0.5),
        locItem('GoblinTotem', 0.5),
      ],
      dist: [0.402, 0.255, 0.225, 0.088, 0.010, 0.010, 0.010],
    },
    {
      id: 'campfire',
      theme: Theme.GoblinCamp,
      size: [6, 8, 6],
      weight: 1,
      items: [
        locItem('fire_pit'),
        locItem('wood_wall_log', 0.5, 6),
        locItem('Goblin', 0.5, 3),
        locItem('GoblinBrute', 0.5),
        locItem('GoblinShaman', 0.5),
      ],
      dist: [0.206, 0.245, 0.235, 0.186, 0.088, 0.030, 0.010],
    },
    {
      id: 'refusepit',
      theme: Theme.GoblinCamp,
      size: [5, 8, 4],
      weight: 0.5,
      items: [
        locItem('fire_pit'),
        locItem('BlackMetalScrap', 0.2),
        locItem('Dandelion', 0.5, 4),
        locItem('BoneFragments', 0.5, 4),
        locItem('Goblin', 0.5, 2),
      ],
      dist: [0.235, 0.196, 0.275, 0.206, 0.078, 0.000, 0.010],
    },
    {
      id: 'tent1',
      theme: Theme.GoblinCamp,
      size: [12, 8, 12],
      weight: 1,
      items: [
        locItem('fire_pit', 0.5),
        locItem('wood_wall_log', 0.5, 2),
        locItem('TreasureChest_heath', 0.3),
        locItem('Goblin', 0.5, 3),
        locItem('GoblinShaman', 0.5),
      ],
      dist: [0.539, 0.373, 0.088],
    },
    {
      id: 'tent02',
      theme: Theme.GoblinCamp,
      size: [12, 8, 12],
      weight: 1,
      items: [
        locItem('fire_pit', 0.5),
        locItem('wood_wall_log', 0.5, 2),
        locItem('TreasureChest_heath', 0.2),
        locItem('Goblin', 0.5, 3),
      ],
      dist: [0.588, 0.353, 0.030, 0.029],
    },
    {
      id: 'hut1',
      theme: Theme.GoblinCamp,
      size: [8, 8, 10],
      weight: 1,
      items: [
        locItem('fire_pit', 0.5),
        locItem('wood_wall_log', 0.5, 2),
        locItem('Goblin', 0.5, 3),
      ],
      dist: [0.353, 0.324, 0.235, 0.069, 0.019],
    },
    {
      id: 'hut02',
      theme: Theme.GoblinCamp,
      size: [10, 8, 12],
      weight: 1,
      items: [
        locItem('fire_pit', 0.5),
        locItem('wood_wall_log', 0.5, 2),
        locItem('TreasureChest_heath', 0.3),
        locItem('Goblin', 0.5, 3),
        locItem('GoblinBrute', 0.1),
        locItem('GoblinShaman', 0.5),
      ],
      dist: [0.618, 0.314, 0.068],
    },
    {
      id: 'hut03',
      theme: Theme.GoblinCamp,
      size: [10, 8, 16],
      weight: 1,
      items: [
        locItem('fire_pit', 0.5),
        locItem('wood_wall_log', 0.5, 2),
        locItem('TreasureChest_heath', 0.3),
        locItem('BlackMetalScrap', 0.2),
        locItem('Dandelion', 0.5, 4),
        locItem('Goblin', 0.5, 5),
        locItem('GoblinArcher'),
        locItem('GoblinBrute', 0.1),
        locItem('GoblinShaman', 0.5),
      ],
      dist: [0.676, 0.284, 0.030, 0.010],
    },
  ],
};
